import { BufferBridge as Buffer } from './buffer/buffer';

export function parseUserToken(token: string): { uuid: string } {
  const infoPart = token && token.split('.')[1]!;
  return JSON.parse(Buffer.from(infoPart, 'base64').toString());
}
